import { render, staticRenderFns } from "./count-to.vue?vue&type=template&id=37c02e52"
import script from "./count-to.vue?vue&type=script&lang=js"
export * from "./count-to.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports